import { createFileRoute } from '@tanstack/react-router'
import GuestsPage from '@/features/guests/components'

export const Route = createFileRoute('/_authenticated/dashboard/guests')({
  component: GuestsPage,
})
